import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsRetrieveGroupBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Retrieve group</div>
          <div className="text">
            Retrieves the details of an existing group, specified by its id or urlName.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                heading: 'apiKey',
                subheading: 'string',
                description: 'Your secret API key.',
              },
              {
                heading: 'id',
                subheading: 'string (optional)',
                description: "The group's unique identifier.",
              },
              {
                heading: 'urlName',
                subheading: 'string (optional)',
                description: "The group's unique urlName.",
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">Returns a group object, if a valid id or urlName was supplied.</div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/groups/retrieve</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/groups/retrieve"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d id=553c3ef8b8cdcd1501ba1235`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba1235",
  "name": "Product",
  "description": "Ideas related to the product surface area.",
  "urlName": "product"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
